import { NavTreeItem } from "../../../../components/common/navigation";
import { useTranslation } from "../../../../hooks/useTranslation";
import { UserRole } from "../../../../models/user.model";

const ALL_ROLES: UserRole[] = [UserRole.User, UserRole.Manager, UserRole.Admin];

// Static-content topic — no backend data, so this is a single leaf NavTreeItem
// with no children, same shape as the Certificates/Skills Matrix topics.
export const useProfessionalSummaryFaqTree = (): NavTreeItem | null => {
    const { t } = useTranslation();

    return {
        id: "professional-summary",
        label: t("FAQ_TOPIC_PROFESSIONAL_SUMMARY", undefined, "Professional Summary"),
        path: "professional-summary",
        requiredRoles: ALL_ROLES,
    };
};
